var React = require('react');

function YinYang (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504a124,124,0,0,1,0-248A124,124,0,0,0,248,8Zm0,152a32,32,0,1,1,32-32A32,32,0,0,1,248,160Zm0,192a32,32,0,1,0,32,32A32,32,0,0,0,248,352Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M248,160a32,32,0,1,0-32-32A32,32,0,0,0,248,160ZM248,8a124,124,0,0,1,0,248,124,124,0,0,0,0,248c137,0,248-111,248-248S385,8,248,8Zm0,408a32,32,0,1,1,32-32A32,32,0,0,1,248,416Z","className":"fa-primary","key":2})]);
}

YinYang.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = YinYang;

YinYang.default = YinYang;
